import { Action, createReducer, on } from '@ngrx/store';
import {
  initialNotificationState,
  NotificationState
} from '../states/notification.state';
import {
  deleteAllNotificationSuccess,
  deleteNotification,
  deleteNotificationSuccess,
  loadMoreNotification,
  loadMoreNotificationSuccess,
  loadNotification,
  loadNotificationError,
  loadNotificationSuccess,
  markAsReadNotification,
  markAsReadNotificationSuccess,
  notificationError,
  readAllNotificationSuccess
} from '../actions/notification.action';
import {
  initialSingleNotificationState,
  SingleNotificationState
} from '../states/single-notification.state';

const reducer = createReducer(
  initialNotificationState,
  on(loadNotification, state => ({
    ...state,
    notification: [],
    loading: true,
    error: ''
  })),
  on(loadNotificationError, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(loadNotificationSuccess, (state, { payload }) => ({
    ...state,
    notification:
      payload?.data?.map(notification => ({
        ...initialSingleNotificationState,
        notification
      })) || null,
    pageInfo: payload.pageInfo || null,
    loading: false,
    error: ''
  })),

  on(loadMoreNotification, state => ({
    ...state,
    loading: true,
    error: ''
  })),

  on(loadMoreNotificationSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    pageInfo: payload?.pageInfo,
    notification: state.notification.concat(
      payload?.data?.map(notification => ({
        ...initialSingleNotificationState,
        notification
      })) || []
    )
  })),

  // read notification
  on(markAsReadNotification, (state, { payload }) => ({
    ...state,
    notification: state.notification.map(
      (notification: SingleNotificationState) => {
        if (notification.notification?.ID === payload.notificationID) {
          return {
            ...notification,
            error: '',
            loading: true
          };
        }
        return notification;
      }
    )
  })),

  on(markAsReadNotificationSuccess, (state, { payload }) => ({
    ...state,
    notification:
      state?.notification?.map((notification: SingleNotificationState) => {
        if (notification.notification?.ID === payload.ID) {
          return {
            ...notification,
            error: '',
            loading: false,
            notification: payload
          };
        }
        return notification;
      }) || []
  })),

  on(notificationError, (state, { payload }) => ({
    ...state,
    notification: state.notification.map(
      (notification: SingleNotificationState) => {
        if (notification.notification?.ID === payload.notificationID) {
          return {
            ...notification,
            error: payload.error,
            loading: false
          };
        }
        return notification;
      }
    )
  })),

  // delete notification
  on(deleteNotification, (state, { payload }) => ({
    ...state,
    notification: state.notification.map(
      (notification: SingleNotificationState) => {
        if (notification.notification?.ID === payload.notificationID) {
          return {
            ...notification,
            error: '',
            loading: true
          };
        }
        return notification;
      }
    )
  })),

  on(deleteNotificationSuccess, (state, { payload }) => {
    const filtered = [...state.notification].filter(
      (notificationState: SingleNotificationState) => {
        return notificationState.notification?.ID !== payload?.notificationID;
      }
    );

    return {
      ...state,
      notification: filtered
    };
  }),

  on(readAllNotificationSuccess, state => {
    return {
      ...state,
      notification:
        state.notification?.map((n: SingleNotificationState) => {
          return {
            ...n,
            notification: {
              ...n.notification,
              status: 'READ'
            }
          } as SingleNotificationState;
        }) || []
    };
  }),

  on(deleteAllNotificationSuccess, state => {
    return {
      ...state,
      notification: [],
      pageInfo: null
    };
  })
);

export function NotificationReducer(
  state: NotificationState | undefined,
  action: Action
): NotificationState {
  return reducer(state, action);
}
